export default (function (obj) {
  return obj && obj.__isYupSchema__;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/yup/es/util/isSchema.js
// module id = 17
// module chunks = 0